import {
  AlignItems,
  CfAlignItems,
  CfJustifyContent,
  JustifyContent,
} from "types/generic/types";

interface CfJustifyContentDictionary {
  [key: string]: JustifyContent;
}

const CF_JUSTIFY_CONTENT_DICTIONARY: CfJustifyContentDictionary = {
  "flex-start": "start",
  center: "center",
  "flex-end": "end",
};

interface ConvertCfJustifyContentPropsReturn {
  justifyContent?: JustifyContent;
}

export const convertCfJustifyContentProps = (
  cfProp: CfJustifyContent | undefined | null,
): ConvertCfJustifyContentPropsReturn => {
  return {
    justifyContent: cfProp ? CF_JUSTIFY_CONTENT_DICTIONARY[cfProp] : undefined,
  };
};

// ALIGN_ITEMS
interface CfAlignItemsDictionary {
  [key: string]: AlignItems;
}

const CF_ALIGN_ITEMS_DICTIONARY: CfAlignItemsDictionary = {
  "flex-start": "start",
  center: "center",
  "flex-end": "end",
};

interface ConvertCfAlignItemsPropsReturn {
  alignItems?: AlignItems;
}

export const convertCfAlignItemsProps = (
  cfProp: CfAlignItems | undefined | null,
): ConvertCfAlignItemsPropsReturn => {
  return {
    alignItems: cfProp ? CF_ALIGN_ITEMS_DICTIONARY[cfProp] : undefined,
  };
};
